var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comparison-stations"},[_c('h6',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t("page.referralForm.comparisonStations.title")))]),_c('div',{staticClass:"table"},_vm._l((_vm.descriptionsList),function(description,index){return _c('TableInfoBlock',{key:index,staticClass:"table-info-block",attrs:{"description":description}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }